import { getEncodedParams } from 'helpers/encodeParams';

export const campaignEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/campaign?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const campaignCalloutsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/campaign/callouts?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const campaignActiveChannelsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/meta/active-channels?start=${encodedParams.start}&end=${encodedParams.end}`;
};



// WEBPACK FOOTER //
// ./src/services/campaign/selectors.js